import { Col, Row, Spin } from "antd";
import { useEffect, useState } from "react";
import TaskItem from "src/components/MyTasks/TaskItem";
import { INVENTORIES_ARRAY, MAPPING_LABEL_TO_KEY } from "src/entity/common/common.constant";
import { ApprovalReportResponse, SubmitMonthlyResponse } from "src/entity/my-tasks/my-tasks";
import { useDidMount } from "src/hook/useDidMount";
import { myTasksStore } from "src/stores/my-tasks-store";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import "./MyTasks.css";

const MyTasksComponent = () => {
  const profile = profileStore(useShallow((state) => state.profile));
  const getMyTasks = myTasksStore(useShallow((state) => state.getMyTasks));
  const loading = myTasksStore(useShallow((state) => state.loading));
  const data = myTasksStore(useShallow((state) => state.data));
  const [hoveredTitle, setHoveredTitle] = useState<string | null>(null);

  useDidMount(() => {
    getMyTasks();
  });

  useEffect(() => {
    if (profile?.activeCompany) {
      getMyTasks();
    }
  }, [profile?.activeCompany]);

  const lists = INVENTORIES_ARRAY;
  // console.log("isHovered :: ", hoveredTitle);
  return (
    <Row className="p-12">
      <Spin spinning={loading}>
        <Row gutter={[48, 84]} justify={"start"} className="my-tasks">
          {lists.map((item) => {
            // "Other" menu is visible only for TPC-RY and TPE companies
            const isVisible = item === "Others" ? ["TPC-RY", "TPE"].includes(String(profile?.activeCompany?.companyName)) : true;
            if (!isVisible) return null;
            return (
              <Col span={8}>
                <TaskItem
                  title={item}
                  totalTasks={data?.totalTasks[MAPPING_LABEL_TO_KEY[item]] as number}
                  isHovered={hoveredTitle}
                  onHover={() => setHoveredTitle(item)}
                  onLeave={() => setHoveredTitle(null)}
                  submitReport={data?.submitReport as SubmitMonthlyResponse}
                  approvalReport={data?.approvalReport as ApprovalReportResponse}
                />
              </Col>
            );
          })}
        </Row>
      </Spin>
    </Row>
  );
};

export default MyTasksComponent;
